import React from 'react';

const Error = () => {
    return (  
        <main>
            <h1>This page does not exist👋</h1>
        </main>
    );
}
 
export default Error;